import React from 'react'
import visually1 from '../../assets/images/features/visually1.png'
import visually2 from '../../assets/images/features/visually2.png'
import visually3 from '../../assets/images/features/visually3.png'
import visually4 from '../../assets/images/features/visually4.png'
import Loadable from '@loadable/component'
import { v4 as uuidv4 } from 'uuid';
import { config } from "react-spring";

const Carousel = Loadable(() => import('react-spring-3d-carousel'))
const OwlCarousel = Loadable(() => import('react-owl-carousel3'))


const options = {
  loop: true,
  nav: true,
  dots: false,
  autoplayHoverPause: true,
  autoplay: true,
  margin: 30,
  navText: [
      "<i class='flaticon-left-1'></i>",
      "<i class='flaticon-right-1'></i>"
  ],
  responsive: {
      0: {
          items: 1,
      },
      768: {
          items: 1,
      },
      992: {
          items: 1,
      }
  }
};

const VisuallyAppealing = () => {
    const [display, setDisplay] = React.useState(false);
    const [goToSlide, setgoToSlide] = React.useState(0);
    const [offsetRadius, setoffsetRadius] = React.useState(2);
    const [showNavigation, setshowNavigation] = React.useState(true);
    const [_config, setconfig] = React.useState(config.default);

    const slides = [
        {
          key: uuidv4(),
          content: <img src={visually1} alt="1" style={{maxWidth: 'inherit'}} />
        },
        {
          key: uuidv4(),
          content: <img src={visually2} alt="2" style={{maxWidth: 'inherit'}} />
        },
        {
          key: uuidv4(),
          content: <img src={visually3} alt="3" style={{maxWidth: 'inherit'}} />
        },
        {
          key: uuidv4(),
          content: <img src={visually4} alt="4" style={{maxWidth: 'inherit'}} />
        },      
      ].map((slide, index) => {
        return { ...slide, onClick: () => setgoToSlide(index) };
      });
    

    React.useEffect(() => {
        setDisplay(true);
        
    }, [])

    return (
      <div className="visually-area">
        <div className="section-title">
            <h1 style={{color: "#fff"}}>visually appealing</h1>
        </div>
        {typeof window !== `undefined` && <div className="testimonials-wrapper">
              <Carousel
              slides={slides}
              goToSlide={goToSlide}
              offsetRadius={offsetRadius}
              showNavigation={showNavigation}
              animationConfig={_config}
              />
        </div>}

        {display ? <OwlCarousel 
                    className="testimonials-wrapper-mobile testimonials-slides owl-carousel owl-theme"
                    {...options}
                > 
                    <div className="single-testimonials-item">
                      <img src={visually1} alt="about" />
                    </div>
                    <div className="single-testimonials-item">
                       <img src={visually2} alt="about" />
                    </div>
                    <div className="single-testimonials-item">
                       <img src={visually3} alt="about" />
                    </div>
                    <div className="single-testimonials-item">
                       <img src={visually4} alt="about" />
                    </div>               
                </OwlCarousel> : ''}
      </div>
    )
}

export default VisuallyAppealing;